<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="分成方式"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="21">分成收益</el-radio>
            <el-radio :label="22">流量收益</el-radio>
            <el-radio :label="23">押金</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额" prop="cash">
          <el-input v-model="form.cash" placeholder="金额"></el-input>元
        </el-form-item>
        <el-form-item label="分成日期">
          <el-date-picker
            v-model="form.create_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="用户姓名">
          <el-input v-model="form.name" placeholder="用户姓名"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { cash_rules } from "../rule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: cash_rules,
      addServiceDialog: false,
      admin_id: "",
      coop_id:'',
      device: {},
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.admin_id = this.$route.query.id;
    this.coop_id = this.$route.query.cid;
  },
  methods: {
    open(row) {
      this.device = row;
      this.addServiceDialog = true;
    },

    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/devicePlanProfit/addTest";
      this.form.device_sn = this.device.device_sn;
      this.form.mechanism_id = this.device.mechanism_id;
      this.form.admin_id = this.device.invest_id;
      this.form.handle_id = this.manager.id;
      this.form.handle_name = this.manager.name;
      this.form.cooperator_id = this.coop_id;


    let p = {
        device_sn: this.device.device_sn,
        user_id: '1',
        name: this.form.name,
        role: 'stu',
        type: 1,
        create_time: this.form.create_time
      }


      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
      });


      this.$axios.post('/device/openRecord/insert', p)

    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>